<template>
  <div class="crm-dashboard">
    <!-- <b-row class="row-spacing">
      <b-col cols="12" class="portlet-wrapper">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white mb-0">Global Filters</h3>
          </div>
          <b-card-body class="portlet-body">
            <GlobalFilterBar
              :base-api="baseApi"
              :access-token="accessToken"
              @filters-changed="handleFiltersChanged"
              @search="handleSearch"
            />
            <div v-if="isLoading" class="text-center py-2">
              <b-spinner variant="primary" label="Loading dashboard" />
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row> -->

    <b-row class="row-spacing">
      <b-col cols="12" class="portlet-wrapper">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white mb-0">CRM Summary</h3>
          </div>
          <b-card-body class="portlet-body kpi-panel-body">
            <b-row class="summary-kpi-row">
              <b-col
                v-for="card in summaryCards"
                :key="card.key"
                cols="12"
                sm="6"
                md="4"
                lg="3"
                xl="2"
                class="summary-kpi-col"
              >
                <kpi-card
                  :title="card.title"
                  :value="card.value"
                  :subtitle="card.subtitle"
                  :color="card.color"
                />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { BRow, BCol, BCard, BCardBody, BSpinner } from 'bootstrap-vue';
import GlobalFilterBar from '@/components/dashboard/GlobalFilterBar.vue';
import KpiCard from '@/components/dashboard/KpiCard.vue';

const emptyPipeline = () => ({
  total_leads: { count: 0, conversion_rate: null },
  site_visit_interested: { count: 0, conversion_rate: null },
  qualified_interested_leads: { count: 0, conversion_rate: null },
});

const emptySales = () => ({
  negotiation: { count: 0 },
  total_closures: { count: 0 },
  site_visit_done: { count: 0 },
  token: { count: 0 },
  commission: { count: 0 },
  closure_meeting: { count: 0 },
  payment: { count: 0 },
  total_payment_revenue: { value: 0 },
});

export default {
  name: 'CrmDashboard',
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BSpinner,
    GlobalFilterBar,
    KpiCard,
  },
  data() {
    return {
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken: localStorage.getItem('accessToken'),
      filters: {
        date_from: moment().startOf('month').format('YYYY-MM-DD'),
        date_to: moment().format('YYYY-MM-DD'),
      },
      presalesPipeline: emptyPipeline(),
      salesPipeline: emptySales(),
      isLoading: false,
      initialFetched: false,
      _fetchTimer: null,
    };
  },
  computed: {
    summaryCards() {
      const presales = this.presalesPipeline;
      const sales = this.salesPipeline;
      const totalCustomers = Number(presales.total_leads?.count) || 0;
      const siteVisitInterested = Number(presales.site_visit_interested?.count) || 0;
      const siteVisitRate = presales.site_visit_interested?.conversion_rate;
      const interested = Number(presales.qualified_interested_leads?.count) || 0;
      const interestedRate = presales.qualified_interested_leads?.conversion_rate;
      const negotiation = Number(sales.negotiation?.count) || 0;
      const closure = Number(sales.total_closures?.count) || 0;
      const token = Number(sales.token?.count) || 0;
      const commission = Number(sales.commission?.count) || 0;
      const siteVisitDone = Number(sales.site_visit_done?.count) || 0;
      const closureMeeting = Number(sales.closure_meeting?.count) || 0;
      const payment = Number(sales.payment?.count) || 0;
      const totalPaymentRevenue = Number(sales.total_payment_revenue?.value) || 0;

      return [
        {
          key: 'total_customer',
          title: 'Total Customer',
          value: this.formatCount(totalCustomers),
          color: 'blue darken-1',
        },
        {
          key: 'site_visit_done',
          title: 'Site Visit Done',
          value: this.formatCount(siteVisitDone),
          color: 'cyan darken-1',
        },
        {
          key: 'negotiation',
          title: 'Negotiation',
          value: this.formatCount(negotiation),
          color: 'amber darken-1',
        },
        {
          key: 'closure',
          title: 'Closure',
          value: this.formatCount(closure),
          color: 'purple darken-1',
        },
        {
          key: 'token',
          title: 'Token',
          value: this.formatCount(token),
          color: 'teal darken-1',
        },
        {
          key: 'commission',
          title: 'Commission',
          value: this.formatCount(commission),
          color: 'blue-grey darken-1',
        },
        {
          key: 'interested',
          title: 'Interested',
          value: this.formatCount(interested),
          color: 'green darken-1',
        },
        {
          key: 'site_visit_interested',
          title: 'Site Visit Interested',
          value: this.formatCount(siteVisitInterested),
          color: 'orange darken-1',
        },
        {
          key: 'closure_meeting',
          title: 'Closure Meeting',
          value: this.formatCount(closureMeeting),
          color: 'light-green darken-1',
        },
        {
          key: 'total_payment_revenue',
          title: 'Total Payment / Revenue',
          value: this.formatCurrency(totalPaymentRevenue),
          color: 'indigo darken-1',
        },
      ];
    },
  },
  beforeDestroy() {
    if (this._fetchTimer) {
      clearTimeout(this._fetchTimer);
    }
  },
  methods: {
    formatCount(value) {
      return Number(value || 0).toLocaleString('en-IN');
    },
    formatCurrency(value) {
      const n = Number(value || 0);
      return `₹ ${n.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
    },
    formatRateSubtitle(rate, suffix) {
      if (rate === null || rate === undefined || rate === '') {
        return null;
      }
      const n = Number(rate);
      if (Number.isNaN(n)) {
        return null;
      }
      return `${n.toFixed(2)}% ${suffix}`;
    },
    handleFiltersChanged(newFilters) {
      this.filters = { ...this.filters, ...newFilters };
      if (!this.initialFetched) {
        this.initialFetched = true;
        this.debouncedFetch();
      }
    },
    handleSearch(newFilters) {
      this.filters = { ...this.filters, ...newFilters };
      this.debouncedFetch(true);
    },
    debouncedFetch(forceRefresh = false) {
      if (this._fetchTimer) {
        clearTimeout(this._fetchTimer);
      }
      this._fetchTimer = setTimeout(() => {
        this._fetchTimer = null;
        this.fetchSummaryData(forceRefresh);
      }, 400);
    },
    async fetchSummaryData(forceRefresh = false) {
      if (!this.baseApi || !this.accessToken) {
        return;
      }
      this.isLoading = true;
      try {
        const params = { ...this.filters };
        if (forceRefresh) {
          params.refresh = 1;
        }
        const response = await axios.get(`${this.baseApi}/dashboard/crm/all`, {
          params,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        });
        const data = response.data?.data || {};
        this.presalesPipeline = {
          ...emptyPipeline(),
          ...(data.presales_pipeline || {}),
        };
        this.salesPipeline = {
          ...emptySales(),
          ...(data.sales_pipeline || {}),
        };
      } catch (error) {
        console.error('Error fetching CRM summary:', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.crm-dashboard {
  padding: 20px;
}

.row-spacing {
  margin-top: 20px;
  margin-bottom: 20px;
}

.portlet {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.portlet:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
}

.portlet-header {
  padding: 10px 16px;
  background: linear-gradient(135deg, #4e73df, #224abe);
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.portlet-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.portlet-body {
  padding: 20px;
  flex-grow: 1;
}

.kpi-panel-body {
  padding: 8px 12px 16px;
}

.summary-kpi-row {
  margin-left: -6px;
  margin-right: -6px;
}

.summary-kpi-col {
  padding-left: 6px;
  padding-right: 6px;
  margin-bottom: 12px;
}
</style>
